import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';

export class ServizioDTO extends LogicalDeleteDTO {
    id: number;
    codServizio: string;
    descrizione: string;
}